module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header', [_c('h1', [_vm._v("About me")])]), _vm._v(" "), (this.page.content) ? _c('main', {
    ref: "pageContent",
    staticClass: "wrap",
    class: _vm.$style.about,
    domProps: {
      "innerHTML": _vm._s(this.page.content.rendered)
    }
  }) : _vm._e(), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f793b566!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 123
// module chunks = 2